import Http from '@/services/Http';
import config from '@/config';

const path = 'organizations/teams';
const teams = new Http(path, config.api);

teams.create = (data) => teams.post(data);

teams.list = (pathParams) =>
  teams.get('', '', pathParams === undefined ? '' : `?${pathParams}`);

teams.listSpecificTeam = (teamId) => teams.get(teamId);

teams.search = (q) => teams.get('', { q }, '');

teams.update = (teamId, data) => teams.put(teamId, data);

teams.remove = (teamId) => teams.delete(teamId);
teams.addUsers = (teamId, data) =>
  teams.post(data, `${teams.path}/${teamId}/users`);
teams.deleteUser = (teamId, userId) =>
  teams.delete(`${teamId}/users/${userId}`);

export default teams;
